export default __webpack_public_path__ + "static/media/Thaumaturge's Gloves of Sovereign Rule.26bf7219.jpg";